import { render, staticRenderFns } from "./Form-credentials.vue?vue&type=template&id=6c00db6a&scoped=true&"
import script from "./Form-credentials.vue?vue&type=script&lang=js&"
export * from "./Form-credentials.vue?vue&type=script&lang=js&"
import style0 from "./Form-credentials.vue?vue&type=style&index=0&id=6c00db6a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00db6a",
  null
  
)

export default component.exports